import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import axios from 'axios';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/perseus';
import { Icon } from '@fiverr-private/fit';
import { r_circle } from '@fiverr-private/fit/icons';

import './style.scss';

export const Online = () => (
    <div className={classNames('status', 'online-indicator')}>
        <Icon className="circle-icon" size={4}>{r_circle}</Icon>
        <I18n k={'general.online'}/>
    </div>
);

export const Vacation = () => (
    <div className={classNames('status', 'ooo-indicator')}>
        <I18n k={'gig_page_perseus.seller_card.unavailable'}/>
    </div>
);

class Status extends Component {
    constructor() {
        super();

        this.state = {
            isOnline: false
        };
    }

    async componentDidMount() {
        const { pathfinderWrapper } = this.context;
        const { pathParameters } = getContext();
        const { username } = pathParameters;
        const url = pathfinderWrapper.pathfinder('is_online', { username });

        try {
            const { is_online } = await axios.get(url);
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                isOnline: is_online
            });
        } catch (error) {
            const status = error.response && error.response.status || 'unknown';
            logger.error(error, { message: `failed to fetch user status with repsonse: ${status}` });
        }
    }

    render() {
        const { isOnVacation } = this.context.general;
        const { isOnline } = this.state;

        if (isOnVacation) {
            return <Vacation/>;
        } else if (isOnline) {
            return <Online/>;
        } else {
            return null;
        }
    }
}

Status.contextTypes = {
    general: PropTypes.object,
    pathfinderWrapper: PropTypes.object
};

export default Status;
